import type { Basemap } from '../../../core/mapV2/indicators';

// "Plan" and "Satellite" use the same Mapbox styles as the current map. "Relief" is an outdoors
// style (contour lines, hillshade) for the third option of the maquette's basemap menu.
export const BASEMAP_STYLES: Record<Basemap, string> = {
    plan: 'mapbox://styles/mapbox/streets-v9',
    satellite: 'mapbox://styles/mapbox/satellite-streets-v12',
    relief: 'mapbox://styles/mapbox/outdoors-v12',
};

// Whole of metropolitan France, used until the organization's extent is known.
export const DEFAULT_VIEW = { longitude: 2.35, latitude: 46.6, zoom: 5 } as const;

export const FIT_BOUNDS_OPTIONS = { animate: false, padding: 100 } as const;

export const MIN_ZOOM = 3;
export const MAX_ZOOM = 20;
